<template>
  <div>
    <div
      class="main-menu menu-fixed menu-light menu-accordion menu-shadow"
      data-scroll-to-active="true"
    >
      <div class="navbar-header">
        <ul class="nav navbar-nav flex-row">
          <li class="nav-item mr-auto">
            <a @click="openRoute('dashboard')" class="navbar-brand">
              <h2 class="brand-text mb-0">Fiziklar kengashi</h2>
            </a>
          </li>
          <li class="nav-item nav-toggle">
            <a class="nav-link modern-nav-toggle pr-0" data-toggle="collapse">
              <i
                class="feather icon-x d-block d-xl-none font-medium-4 primary toggle-icon"
              />
              <i
                class="toggle-icon feather icon-disc font-medium-4 d-none d-xl-block collapse-toggle-icon primary"
                data-ticon="icon-disc"
              />
            </a>
          </li>
        </ul>
      </div>
      <div class="shadow-bottom"></div>
      <div class="main-menu-content">
        <ul
          class="navigation navigation-main"
          data-menu="menu-navigation"
          id="main-menu-navigation"
        >
          <template
            v-if="
              (permissionConstants &&
                permissionConstants.COURSE_VIEW &&
                $store.state.userPermissions.includes(
                  permissionConstants.COURSE_VIEW
                )) ||
                $store.state.currentUser.isTeacher
            "
          >
            <li :class="currentRouteName === 'courses' ? 'active' : ''">
              <a @click.prevent="openRoute('courses')">
                <i class="feather icon-list" />
                <span class="menu-item" data-i18n="Shop">Kurslar</span>
              </a>
            </li>
          </template>

          <template
            v-if="
              permissionConstants &&
                permissionConstants.USERS_VIEW &&
                $store.state.userPermissions.includes(
                  permissionConstants.USERS_VIEW
                )
            "
          >
            <li :class="currentRouteName === 'users-list' ? 'active' : ''">
              <a @click.prevent="openRoute('users-list')">
                <i class="feather icon-users" />
                <span class="menu-item" data-i18n="Shop">Foydalanuvchilar</span>
              </a>
            </li>
          </template>

          <template
            v-if="
              permissionConstants &&
                permissionConstants.USERS_VIEW &&
                $store.state.userPermissions.includes(
                  permissionConstants.USERS_VIEW
                )
            "
          >
            <li :class="currentRouteName === 'abiturient-list' ? 'active' : ''">
              <a @click.prevent="openRoute('abiturient-list')">
                <i class="feather icon-users" />
                <span class="menu-item" data-i18n="Shop">Abiturientlar</span>
              </a>
            </li>
          </template>

          <template
            v-if="
              permissionConstants &&
                permissionConstants.REFERENCE_VIEW &&
                $store.state.userPermissions.includes(
                  permissionConstants.REFERENCE_VIEW
                )
            "
          >
            <li :class="currentRouteName === 'news' ? 'active' : ''">
              <a @click.prevent="openRoute('news')">
                <i class="fa fa-th" />
                <span class="menu-item" data-i18n="Shop">Yangiliklar</span>
              </a>
            </li>
            <li :class="currentRouteName === 'about-us' ? 'active' : ''">
              <a @click.prevent="openRoute('about-us')">
                <i class="feather icon-clipboard" />
                <span class="menu-item" data-i18n="Shop">Biz haqimizda</span>
              </a>
            </li>
            <li class="nav-item has-sub open">
              <a href="#">
                <i class="feather icon-layout"></i>
                <span class="menu-title" data-i18n="Content"
                  >Ma'lumotnomalar</span
                >
              </a>
              <ul class="menu-content" style="">
                <li :class="currentRouteName === 'top-courses' ? 'active' : ''">
                  <a @click.prevent="openRoute('top-courses')">
                    <i class="fa fa-wpforms" />
                    <span class="menu-item" data-i18n="Shop">Top kurslar</span>
                  </a>
                </li>
                <li :class="currentRouteName === 'subject' ? 'active' : ''">
                  <a @click.prevent="openRoute('subject')">
                    <i class="fa fa-wpforms" />
                    <span class="menu-item" data-i18n="Shop">Fanlar</span>
                  </a>
                </li>
                <li :class="currentRouteName === 'skills' ? 'active' : ''">
                  <a @click.prevent="openRoute('skills')">
                    <i class="fa fa-th" />
                    <span class="menu-item" data-i18n="Shop">Yo'nalishlar</span>
                  </a>
                </li>
                <li
                  :class="currentRouteName === 'category-list' ? 'active' : ''"
                >
                  <a @click.prevent="openRoute('category-list')">
                    <i class="fa fa-th" />
                    <span class="menu-item" data-i18n="Shop"
                      >Kategoriyalar</span
                    >
                  </a>
                </li>
                <li :class="currentRouteName === 'tariff-list' ? 'active' : ''">
                  <a @click.prevent="openRoute('tariff-list')">
                    <i class="feather icon-credit-card" />
                    <span class="menu-item" data-i18n="Shop">Tariflar</span>
                  </a>
                </li>
                <li
                  :class="currentRouteName === 'discount-list' ? 'active' : ''"
                >
                  <a @click.prevent="openRoute('discount-list')">
                    <i class="feather icon-bar-chart-2" />
                    <span class="menu-item" data-i18n="Shop">Chegirmalar</span>
                  </a>
                </li>
                <li :class="currentRouteName === 'badges-list' ? 'active' : ''">
                  <a @click.prevent="openRoute('badges-list')">
                    <i class="feather icon-award" />
                    <span class="menu-item" data-i18n="Shop">Nishonlar</span>
                  </a>
                </li>
              </ul>
            </li>
            <li class="nav-item has-sub open">
              <a href="#">
                <i class="feather icon-layout"></i>
                <span class="menu-title" data-i18n="Content">Testlar</span>
              </a>
              <ul class="menu-content" style="">
                <li :class="currentRouteName === 'test-list' ? 'active' : ''">
                  <a @click.prevent="openRoute('test-list')">
                    <i class="fa fa-wpforms" />
                    <span class="menu-item" data-i18n="Shop"
                      >Testlarni tahrirlash</span
                    >
                  </a>
                </li>
                <li
                  :class="
                    currentRouteName === 'test-specialities' ? 'active' : ''
                  "
                >
                  <a @click.prevent="openRoute('test-specialities')">
                    <i class="fa fa-wpforms" />
                    <span class="menu-item" data-i18n="Shop">Yo'nalishlar</span>
                  </a>
                </li>
                <li
                  :class="
                    currentRouteName === 'test-monitoring' ? 'active' : ''
                  "
                >
                  <a @click.prevent="openRoute('test-monitoring')">
                    <i class="fa fa-wpforms" />
                    <span class="menu-item" data-i18n="Shop">Monitoring</span>
                  </a>
                </li>
              </ul>
            </li>
          </template>
        </ul>
      </div>
    </div>

    <div class="app-content content">
      <!-- BEGIN: Header-->
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <navigation />
      <!-- END: Header-->
      <div class="content-wrapper p-1">
        <div class="content-body">
          <transition mode="out-in" name="fade">
            <router-view />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from "../components/Navigation";
import VueJwtDecode from "vue-jwt-decode";
import PermissionConstants from "../permissionConstants";
import TokenService from "../services/TokenService";

export default {
  name: "MainLayout",
  components: { Navigation },
  data() {
    return {
      permissionConstants: [],
    };
  },
  methods: {
    openRoute(routeName) {
      this.$router.push({ name: routeName });
      this.$store.commit("setCurrentRouteName", routeName);
    },
    parseUserPermissions(userPermissions) {
      let permissions = userPermissions.substring(
        0,
        userPermissions.length - 1
      );
      this.$store.commit(
        "commitUserPermissions",
        permissions.split(",").map(Number)
      );
    },
    getUserByToken() {
      this.$api.get("admin/management/userbytoken").then((res) => {
        if (res.statusCode === 200) {
          this.$store.commit("commitCurrentUser", res.result);
        }
      });
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  created() {
    let hasToken = !!TokenService.getToken();
    if (hasToken) {
      this.getUserByToken();
      let decodedAuth = VueJwtDecode.decode(TokenService.getToken());
      console.log(decodedAuth, " decoded");
      this.parseUserPermissions(decodedAuth.Permissions);
      this.permissionConstants = PermissionConstants;
    }
  },
};
</script>

<style scoped></style>

<style>
::-webkit-scrollbar {
  height: 7px;
  width: 7px;
  background: #f8f8f8;
}

::-webkit-scrollbar-thumb:vertical {
  background: #7367f0;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:horizontal {
  background: #7367f0;
  border-radius: 10px;
}

.header-navbar.floating-nav {
  width: calc(100% - calc(1rem * 2) - 260px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
 {
  opacity: 0;
}

.katex-display {
  text-align: inherit !important;
}

.katex-display > .katex {
  display: block;
  text-align: inherit !important;
  white-space: normal !important;
}
</style>
